import { Main } from "../components/feature/bookedServices";

export default function BookedService()
{
    return(
<section className="">
    <Main/>
</section>
    );
}